let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hnpuv")).then(() => parcelRequire('6fRvM'));